module.exports = __webpack_public_path__ + "img/bepreisung_2.0974f9fa.png";